export default [
  {
    value: "0",
    label: "0",
  },
  {
    value: "1",
    label: "1 to 9,999",
  },
  {
    value: "2",
    label: "10,000 to 24,999",
  },
  {
    value: "3",
    label: "25,000 to 99,999",
  },
  {
    value: "4",
    label: "100,000 to 499,999",
  },
  {
    value: "5",
    label: "500,000 to 999,999",
  },
  {
    value: "6",
    label: "1,000,000 to 4,999,999",
  },
  {
    value: "7",
    label: "5,000,000 to 9,999,999",
  },
  {
    value: "8",
    label: "10,000,000 to 49,999,999",
  },
  {
    value: "9",
    label: "50,000,000 to greater ",
  },
];
